import { z } from 'zod';
import { PasswordSchema } from './password.js';
/** Paso 1: pedir el código de recuperación al email. */
export const ForgotPasswordRequest = z.object({
    email: z.string().email(),
}).strict();
/** Paso 2: verificar el código recibido por email. */
export const VerifyResetTokenRequest = z.object({
    email: z.string().email(),
    token: z.string().min(4).max(12),
}).strict();
/** Paso 3: setear la nueva contraseña con el código validado. */
export const ResetPasswordRequest = z.object({
    email: z.string().email(),
    token: z.string().min(4).max(12),
    newPassword: PasswordSchema,
}).strict();
/** Respuesta genérica (no filtra si el email existe). */
export const OkResponse = z.object({ ok: z.boolean() }).strict();
